import { render, staticRenderFns } from "./WelcomeComponent.vue?vue&type=template&id=ef095fc2&scoped=true&"
import script from "./WelcomeComponent.vue?vue&type=script&lang=ts&"
export * from "./WelcomeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeComponent.vue?vue&type=style&index=0&id=ef095fc2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef095fc2",
  null
  
)

export default component.exports